import React from 'react';
const Privacy = () => {

    return (
        <div className="row justify-content-center align-items-center mb-2">
            Privacy Policy
        </div>
    )
}
export default Privacy;